/*
 * @Author: cheesekun
 * @Date: 2021-04-07 15:50:51
 * @LastEditors: cheesekun
 * @LastEditTime: 2021-04-07 15:51:19
 * @FilePath: \dc-vizier-tpl-h5\src\core\index.js
 */
import Tip from '@/components/Tip/tip'
import fixed from '@/directive/fixed'
import Vue from 'vue'

Vue.use(fixed)
Vue.prototype.$tip = Tip
